import { useTranslation } from 'react-i18next';

import {
  bannerContainer,
  bannerWrapper,
  buttonWrapper,
  containerStyle,
  iconContainer,
  iconWrapper,
  subTextContainer,
  textContainer,
  titleStyle
} from './styles.ts';

import FireReactionShape from '@/components/common/svg/shapes/FireReactionShape.tsx';
import LoveCupidShape from '@/components/common/svg/shapes/LoveCupidShape.tsx';

interface BannerProps {
  openPayWall: () => void;
}

const Banner = ({ openPayWall }: BannerProps) => {
  const { t } = useTranslation();

  return (
    <div style={containerStyle} onClick={openPayWall}>
      <div style={bannerWrapper}>
        <div style={bannerContainer}>
          <div style={iconWrapper}>
            <div style={iconContainer}>
              <FireReactionShape
                width={38}
                height={38}
                fillColor="#fff"
                style={{ marginBottom: '2px' }}
              />
            </div>
          </div>
          <div style={textContainer}>
            <p style={titleStyle}>{t('banner.get_gifts')}</p>
            <div style={subTextContainer}>
              {t('banner.get_gifts_learn_more')}
            </div>
          </div>
          <div style={buttonWrapper}>
            <LoveCupidShape
              width={46}
              height={46}
              style={{ marginRight: 20 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
